import * as THREE from 'three'

/**
 * Creates a new Three.js renderer.
 */
export const createRenderer = (
  canvas: HTMLCanvasElement,
  width: number,
  height: number,
  pixelRatio: number,
) => {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
    alpha: true,
    preserveDrawingBuffer: true,
  })
  renderer.outputEncoding = THREE.sRGBEncoding

  renderer.setSize(width, height)
  renderer.setPixelRatio(pixelRatio)

  return renderer
}
